import articleImg from '../assets/images/new-artical.jpg';
import profileImg from '../assets/images/articalsdetails-profile.png';
import heroBg from '../assets/images/aboutus-bg.png';
import doctorImg from '../assets/images/aboutus-docter-img.jpg';
import midImg from '../assets/images/empoweringdoctors-1.jpg';

export const caseStudyCategories = [
  'All',
  'Cardiology',
  'Orthopedics',
  'Pediatrics',
  'Neurology',
  'Oncology',
  'Dermatology',
];

const slugify = (text) =>
  text
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-');

const bodyContent = `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.

Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo. Quisque sit amet est et sapien ullamcorper pharetra.

Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.

Phasellus imperdiet, nulla et dictum interdum, nisi lorem egestas odio, vitae scelerisque enim ligula venenatis dolor. Maecenas nisl est, ultrices nec congue eget, auctor vitae massa. Fusce luctus vestibulum augue ut aliquet. Nunc sagittis dictum nisi, sed ullamcorper ipsum dignissim ac. In a ligula quis sapien tristique lobortis. Sed molestie augue sit amet leo consequat posuere.

Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.`;

const makeComments = () => [
  {
    id: 1,
    author: 'Ralph Edwards',
    avatar: profileImg,
    date: 'Aug 20, 2021',
    text: 'In massa porttitor tincidunt mauris massa ullamcorper sed auctor eu. At fringilla pretium vel nunc sem volutpat cras. In pulvinar eget mollis adipiscing lorem ipsum dolor sit.',
    likes: 21,
    replies: [],
  },
  {
    id: 2,
    author: 'Ralph Edwards',
    avatar: profileImg,
    date: 'Aug 20, 2021',
    text: 'In massa porttitor tincidunt mauris massa ullamcorper sed auctor eu. At fringilla pretium vel nunc sem volutpat cras. In pulvinar eget mollis adipiscing lorem ipsum dolor sit.',
    likes: 21,
    replies: [
      {
        id: 21,
        author: 'Ralph Edwards',
        avatar: profileImg,
        date: 'Aug 21, 2021',
        text: 'In massa porttitor tincidunt mauris massa ullamcorper sed auctor eu. At fringilla pretium vel nunc sem volutpat cras.',
        likes: 5,
        replies: [],
      },
    ],
  },
  {
    id: 3,
    author: 'Ralph Edwards',
    avatar: profileImg,
    date: 'Aug 20, 2021',
    text: 'In massa porttitor tincidunt mauris massa ullamcorper sed auctor eu. At fringilla pretium vel nunc sem volutpat cras. In pulvinar eget mollis adipiscing lorem ipsum dolor sit.',
    likes: 21,
    replies: [],
  },
  {
    id: 4,
    author: 'Ralph Edwards',
    avatar: profileImg,
    date: 'Aug 20, 2021',
    text: 'In massa porttitor tincidunt mauris massa ullamcorper sed auctor eu. At fringilla pretium vel nunc sem volutpat cras. In pulvinar eget mollis adipiscing lorem ipsum dolor sit.',
    likes: 21,
    replies: [],
  },
  {
    id: 5,
    author: 'Ralph Edwards',
    avatar: profileImg,
    date: 'Aug 20, 2021',
    text: 'In massa porttitor tincidunt mauris massa ullamcorper sed auctor eu. At fringilla pretium vel nunc sem volutpat cras. In pulvinar eget mollis adipiscing lorem ipsum dolor sit.',
    likes: 21,
    replies: [],
  },
];

const rawCaseStudies = [
  { category: 'Cardiology', title: 'The trend was noticed during a survey by Bumble', doctor: 'Doctor Malik', specialty: 'Senior Cardiologist, Apollo Hospitals' },
  { category: 'Cardiology', title: 'Advanced Cardiac Life Support – 2024', doctor: 'Doctor Malik', specialty: 'Senior Cardiologist, Apollo Hospitals' },
  { category: 'Cardiology', title: 'Heart failure management in elderly patients', doctor: 'Doctor Priya Nair', specialty: 'Interventional Cardiologist, Fortis' },
  { category: 'Orthopedics', title: 'Minimally invasive knee replacement outcomes', doctor: 'Doctor Arjun Mehta', specialty: 'Orthopedic Surgeon, Max Healthcare' },
  { category: 'Orthopedics', title: 'Spinal fusion recovery protocol study', doctor: 'Doctor Arjun Mehta', specialty: 'Orthopedic Surgeon, Max Healthcare' },
  { category: 'Pediatrics', title: 'Pediatric asthma management in urban settings', doctor: 'Doctor Sunita Rao', specialty: 'Pediatrician, Rainbow Children' },
  { category: 'Pediatrics', title: 'Early intervention for childhood obesity', doctor: 'Doctor Sunita Rao', specialty: 'Pediatrician, Rainbow Children' },
  { category: 'Neurology', title: 'Stroke rehabilitation using modern physiotherapy', doctor: 'Doctor Vikram Iyer', specialty: 'Neurologist, NIMHANS' },
  { category: 'Neurology', title: 'Deep brain stimulation for Parkinson patients', doctor: 'Doctor Vikram Iyer', specialty: 'Neurologist, NIMHANS' },
  { category: 'Oncology', title: 'Immunotherapy response in lung cancer patients', doctor: 'Doctor Kavya Sharma', specialty: 'Oncologist, Tata Memorial' },
  { category: 'Oncology', title: 'Targeted therapy outcomes in breast cancer', doctor: 'Doctor Kavya Sharma', specialty: 'Oncologist, Tata Memorial' },
  { category: 'Dermatology', title: 'Biologic treatment for severe psoriasis cases', doctor: 'Doctor Riya Desai', specialty: 'Dermatologist, Skin & Care Clinic' },
];

export const caseStudies = rawCaseStudies.map((cs, i) => ({
  id: i + 1,
  slug: slugify(cs.title),
  category: cs.category,
  image: articleImg,
  heroImage: heroBg,
  midImage: midImg,
  doctorImage: doctorImg,
  duration: '20 Min',
  date: '20/12/2025',
  views: '2,005',
  title: cs.title,
  description:
    'Attended cardiology update workshop on heart failure management, 2024',
  content: bodyContent,
  doctor: cs.doctor,
  specialty: cs.specialty,
  author: { name: cs.doctor, avatar: doctorImg },
  comments: makeComments(),
}));
